
import api from '@/api';

const namespaced = true;

const state = {
  makerPriorities: [],
};

const mutations = {
  SET_MAKER_PRIORITIES(state, priorities) {
    state.makerPriorities = priorities;
  },
  ADD_MAKER_PRIORITY(state, priority) {
    state.makerPriorities.push(priority);
  },
  SAVE_PRIORITY(state, savePriority) {
    let index = -1;
    state.makerPriorities.forEach((priority, i) => {
      if (savePriority.id === priority.id) {
        index = i;
      }
    });
    state.makerPriorities.splice(index, 1, savePriority);
  },
  DELETE_PRIORITY(state, deletePriority) {
    let index = -1;
    state.makerPriorities.forEach((priority, i) => {
      if (deletePriority.id === priority.id) {
        index = i;
      }
    });
    state.makerPriorities.splice(index, 1);
  },
};

const actions = {
  async fetchMakerPriorities({ commit, dispatch, rootState }, makerId = null) {
    const priorities = await dispatch(`fetchPrioritiesForMaker`, makerId || rootState[`model/client`].company.id);

    commit(`SET_MAKER_PRIORITIES`, priorities);

    return priorities;
  },
  async fetchPrioritiesForMaker(store, makerId) {
    const { data: priorities } = await api.get(`/priorities/maker/${makerId}`);

    return priorities;
  },
  async addPriority({ commit, rootState }, { id, name, makerId }) {
    makerId = makerId || rootState[`model/client`].company.id;
    const { data: newPriority } = await api.post(`/priorities/maker/${makerId}`, { id, name });
    commit(`ADD_MAKER_PRIORITY`, newPriority);

    return newPriority;
  },
  async savePriority({ commit, rootState }, { id, name, makerId }) {
    try {
      makerId = makerId || rootState[`model/client`].company.id;
      const { data: priority } = await api.put(`/priorities/${id}`, { id, name, makerId });
      commit(`SAVE_PRIORITY`, priority);
      return priority;
    } catch (e) {} // eslint-disable-line

    return null;
  },
  async deletePriority({ commit }, priority) {
    try {
      await api.delete(`/priorities/${priority.id}`, priority);
      commit(`DELETE_PRIORITY`, priority);
    } catch (e) {} // eslint-disable-line
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
